import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). The legacy literal 'white'
// modal background maps to surfaceElevated ('#fff' — same pixel in light).
const makeStyles = colors =>
  StyleSheet.create({
    centeredView: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.overlayLight,
    },
    modalView: {
      maxWidth: 481,
      margin: 32,
      backgroundColor: colors.surfaceElevated,
      borderRadius: 16,
      padding: 32,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 4,
      elevation: 5,
    },
    buttonsContainer: {
      flexDirection: 'row',
    },
    title: {
      marginBottom: 24,
    },
    description: {
      marginBottom: 32,
    },
    rippleContainer: {
      alignSelf: 'center',
      marginBottom: 8,
    },
  });

export default makeStyles;
